import React from 'react';
import TextField from '@mui/material/TextField';
import { useTranslation } from 'react-i18next';

interface SwiftInputProps {
  value: string;
  onChange: (value: string) => void;
  disabled: boolean;
}

export default function SwiftInput({ value, onChange, disabled }: SwiftInputProps) {
  const { t } = useTranslation();

  return (
    <TextField
      label={t('formInputs.swiftInputLabel')}
      variant='outlined'
      fullWidth
      value={value ?? ''}
      onChange={(e) => onChange(e.target.value)}
      disabled={disabled}
    />
  );
}
